import {_ as $hgUW1$_} from "@swc/helpers/_/_ts_decorate";
import {css as $hgUW1$css, html as $hgUW1$html, LitElement as $hgUW1$LitElement} from "lit";
import {classMap as $hgUW1$classMap} from "lit-html/directives/class-map";
import {property as $hgUW1$property, customElement as $hgUW1$customElement} from "lit/decorators.js";





let $485ad91fe3754928$export$148c46df640f7a93 = class LitTypewriter extends (0, $hgUW1$LitElement) {
    static #_ = (()=>{
        this.styles = (0, $hgUW1$css)`
    :host {
      display: inline;

      color: var(--typewriter-color);
      font-family: var(--typewriter-font-family);
      font-size: var(--typewriter-font-size);
      font-weight: var(--typewriter-font-weight);
      background-color: var(--typewriter-background-color);
      background: var(--typewriter-background);
      text-transform: var(--typewriter-text-transform);
    }

    .withCursor::after {
      content: var(--typewriter-cursor, "▮");
      font-size: var(--typewriter-cursor-font-size);
      color: var(--typewriter-cursor-color);
      animation-name: var(--typewriter-cursor-animation-name, blink);
      animation-duration: var(--typewriter-cursor-animation-speed, 0.5s);
      animation-timing-function: var(
        --typewriter-cursor-animation-easing,
        cubic-bezier(0.4, 0, 0.2, 1)
      );
      animation-iteration-count: infinite;
    }

    .withCursor.isTyping::after {
      animation: none;
    }

    @keyframes blink {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  `;
    })();
    connectedCallback() {
        super.connectedCallback();
        this._type();
    }
    render() {
        return (0, $hgUW1$html)`<span
      dir="${this._getDirection()}"
      class=${(0, $hgUW1$classMap)({
            text: true,
            withCursor: !this.noCursor,
            isTyping: this.isTyping
        })}
      >${this.typedText}</span
    >`;
    }
    constructor(...args){
        super(...args);
        /**
   * Array of strings to display.
   */ this.strings = [
            "Hello World!",
            "I'm a Typewriter."
        ];
        /**
   * Defines whether to show the cursor or not.
   * Default: true
   */ this.noCursor = false;
        /**
   * Delay after typing a character, in milliseconds.
   * Default: 100
   */ this.typingDelay = 100;
        /**
   * Delay after erasing a character, in milliseconds.
   * Default: 17
   */ this.erasingDelay = 17;
        /**
   * Delay after typing a string, in milliseconds.
   * Default: 1000
   */ this.delayAfterTyping = 1000;
        /**
   * Delay after erasing a string, in milliseconds.
   * Default: 500
   */ this.delayAfterErasing = 500;
        /**
   * Defines whether typing should have a natural effect.
   * When set to true, the typing delay will be multiplied
   * by a random number between 0.5 and 1.5, resulting in a
   * more natural typing effect.
   * Default: false.
   */ this.natural = false;
        /**
   * Array of indices of strings that should be typed right-to-left.
   * Default: []
   */ this.rtlStringIndices = [];
        this.typedText = "";
        this.currentStringIndex = 0;
        this.isTyping = false;
        this._type = ()=>{
            const currentString = this.strings[this.currentStringIndex];
            if (this.typedText.length < currentString.length) {
                this.isTyping = true;
                this.typedText += currentString[this.typedText.length];
                const delay = this.natural ? Math.max((Math.random() + 0.5) * this.typingDelay, 17) : this.typingDelay;
                setTimeout(this._type, delay);
            } else {
                this.isTyping = false;
                setTimeout(this._erase, this.delayAfterTyping);
            }
        };
        this._erase = ()=>{
            if (this.erasingDelay === 0) {
                this.typedText = "";
                this.currentStringIndex = ++this.currentStringIndex % this.strings.length;
                setTimeout(this._type, this.delayAfterErasing + this.typingDelay);
            } else if (this.typedText.length > 0) {
                this.isTyping = true;
                this.typedText = this.typedText.slice(0, this.typedText.length - 1);
                setTimeout(this._erase, this.erasingDelay);
            } else {
                this.isTyping = false;
                this.currentStringIndex = ++this.currentStringIndex % this.strings.length;
                setTimeout(this._type, this.delayAfterErasing + this.typingDelay);
            }
        };
        this._getDirection = ()=>this.rtlStringIndices.indexOf(this.currentStringIndex) > -1 ? "rtl" : "ltr";
    }
};
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Array,
        reflect: true
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "strings", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Boolean
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "noCursor", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Number
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "typingDelay", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Number
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "erasingDelay", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Number
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "delayAfterTyping", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Number
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "delayAfterErasing", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Boolean
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "natural", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Array
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "rtlStringIndices", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: String
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "typedText", void 0);
(0, $hgUW1$_)([
    (0, $hgUW1$property)({
        type: Boolean
    })
], $485ad91fe3754928$export$148c46df640f7a93.prototype, "isTyping", void 0);
$485ad91fe3754928$export$148c46df640f7a93 = (0, $hgUW1$_)([
    (0, $hgUW1$customElement)("lit-typewriter")
], $485ad91fe3754928$export$148c46df640f7a93);




export {$485ad91fe3754928$export$148c46df640f7a93 as LitTypewriter};
//# sourceMappingURL=index.js.map
